import React from 'react';
import { Layout } from 'antd';
import Paragraph from 'antd/es/typography/Paragraph';
import { useLanguage } from '../i18n/LanguageContext';

const { Footer } = Layout;

const AppFooter: React.FC = () => {
  const { t } = useLanguage();
  return (
    <Footer className="footer">
      picmodifier.com ©2020-{new Date().getFullYear()}
      
      <Paragraph type="secondary" style={{ marginTop: 10 }}>
        {t('footer.support.email')}
      </Paragraph>
    </Footer>
  );
};

export default AppFooter; 